import React from 'react'
export function OcultarCelda({ children, item, expandedKeys }) {
  const { key } = item;

  const isExandable = item.children !== null && item.children !== undefined && item.children.length > 0;

  if (isExandable && expandedKeys[key]) {
    return null;
  }

  return <React.Fragment>{children}</React.Fragment>;
}
